import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MonDataPrivacyInfoTypeIconComponent } from './info-type-icon.component';
import { MonDataPrivacyInfoTypeIconService } from './info-type-icon.service';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    imports: [CommonModule, NgbTooltipMfeModule],
    declarations: [MonDataPrivacyInfoTypeIconComponent],
    exports: [MonDataPrivacyInfoTypeIconComponent],
    providers: [MonDataPrivacyInfoTypeIconService],
})
export class MonDataPrivacyInfoTypeIconModule {}
